module.exports = __webpack_public_path__ + "img/IMG_9512_L_BlackMatted_MockedUp.694e2408.jpg";